import { IDeliveryNormalized } from '@data/types'

export enum deliveryStatusClassification {
  pending = 'pending',
  processing = 'processing',
  ready = 'ready',
  outForDelivery = 'outForDelivery',
  unknown = 'unknown',
}

export interface GroupDeliveriesForDashboard {
  [deliveryStatusClassification.outForDelivery]: Array<IDeliveryNormalized>
  [deliveryStatusClassification.ready]: Array<IDeliveryNormalized>
  [deliveryStatusClassification.processing]: Array<IDeliveryNormalized>
  [deliveryStatusClassification.pending]: Array<IDeliveryNormalized>
  [deliveryStatusClassification.unknown]: Array<IDeliveryNormalized>
}
